import React from 'react';

export const OneDriveSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M16.4398 15.3371L16.4401 15.3361L22.7379 19.1084L26.4906 17.5292C27.2532 17.1995 28.0755 17.0304 28.9063 17.0312C29.0447 17.0312 29.1815 17.0375 29.3176 17.0466C28.8664 15.2873 27.914 13.6969 26.576 12.4687C25.238 11.2405 23.5721 10.4274 21.7806 10.1282C19.9892 9.82889 18.1495 10.0564 16.4849 10.783C14.8204 11.5096 13.4027 12.704 12.4042 14.2212C12.4363 14.2208 12.4678 14.2187 12.5 14.2187C13.8919 14.2169 15.2565 14.6042 16.4398 15.3371Z"
			fill="#0364B8"
		/>
		<path
			d="M16.4401 15.3361L16.4398 15.3371C15.2565 14.6042 13.8919 14.2169 12.5 14.2188C12.4678 14.2188 12.4362 14.2208 12.4042 14.2212C11.0419 14.238 9.70995 14.6258 8.55149 15.3428C7.39304 16.0598 6.45186 17.0789 5.8291 18.2906C5.20634 19.5023 4.92553 20.8608 5.01687 22.2202C5.1082 23.5795 5.56822 24.8882 6.34749 26.0057L11.9012 23.6686L14.3701 22.6297L19.8671 20.3164L22.7379 19.1084L16.4401 15.3361Z"
			fill="#0078D4"
		/>
		<path
			d="M29.3176 17.0466C29.1815 17.0375 29.0447 17.0313 28.9063 17.0313C28.0755 17.0304 27.2534 17.2001 26.4908 17.5298L22.7379 19.1084L23.8261 19.7602L27.3933 21.8969L28.9496 22.8291L34.2712 26.0167C34.7547 25.119 35.0053 24.1144 34.9999 23.0948C34.9946 22.0752 34.7336 21.0733 34.2407 20.1807C33.7478 19.2882 33.0388 18.5336 32.1787 17.986C31.3186 17.4385 30.3349 17.1155 29.3176 17.0466Z"
			fill="#1490DF"
		/>
		<path
			d="M28.9496 22.8291L27.3933 21.8969L23.8261 19.7602L22.7379 19.1084L19.8672 20.3164L14.3701 22.6297L11.9013 23.6686L6.34753 26.0057C7.03769 26.998 7.95774 27.8085 9.02911 28.368C10.1005 28.9275 11.2914 29.2194 12.5 29.2188H28.9063C30.0063 29.2191 31.0859 28.9216 32.0305 28.3578C32.975 27.794 33.7493 26.985 34.2712 26.0167L28.9496 22.8291Z"
			fill="#28A8EA"
		/>
	</svg>
);
